module.exports = __webpack_public_path__ + "static/img/booking.b0aa487.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/booking.png
// module id = QCsH
// module chunks = 1